/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useCallback } from 'react'
import { ModalContext } from '../../contexts/modal-context'
import { useSpring, animated } from 'react-spring'
import { Background, ModalWrapper } from './modal-styles'

const Modal = () => {
  const { modalOpen, modalContent, setModalOpen } = useContext(ModalContext)

  const closeModal = () => {
    setModalOpen(false)
  }

  const keyPress = useCallback(
    (event: any) => {
      if (event.key === 'Escape' && modalOpen) {
        setModalOpen(false)
      }
    },
    [modalOpen, setModalOpen]
  )

  useEffect(() => {
    document.addEventListener('keydown', keyPress)
    return () => document.removeEventListener('keydown', keyPress)
  }, [keyPress])

  const animation = useSpring({
    config: {
      duration: 250
    },
    opacity: modalOpen ? 1 : 0,
    transform: modalOpen ? 'translateY(0%)' : 'translateY(-100%)'
  })

  return (
    <>
      {modalOpen && (
        <>
          <Background data-testid="modal-background" onClick={closeModal} />
          <ModalWrapper data-testid="modal" id="modal-wrapper">
            <animated.div id="animation-div" style={animation}>
              {modalContent}
            </animated.div>
          </ModalWrapper>
        </>
      )}
    </>
  )
}

export default Modal
